import { render, staticRenderFns } from "./CarouselCards.vue?vue&type=template&id=646c037e&scoped=true&"
import script from "./CarouselCards.vue?vue&type=script&lang=js&"
export * from "./CarouselCards.vue?vue&type=script&lang=js&"
import style0 from "./CarouselCards.vue?vue&type=style&index=0&id=646c037e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c037e",
  null
  
)

export default component.exports